import { LogMessageWithMeta } from 'types/logging/meta-log.type';

export type LogLevelFilterValueType = 'all' | 'info' | 'warn' | 'debug' | 'error';

type LogLevelFilterType = {
  value: LogLevelFilterValueType;
  displayValue: string;
};

export const logLevelFilter: LogLevelFilterType[] = [
  {
    value: 'all',
    displayValue: 'All'
  },
  {
    value: 'info',
    displayValue: 'Info'
  },
  {
    value: 'warn',
    displayValue: 'Warning'
  },
  {
    value: 'debug',
    displayValue: 'Debug'
  },
  {
    value: 'error',
    displayValue: 'Error'
  }
];

export type LogOrderFilterValueType = 'new-to-old' | 'old-to-new';

type LogOrderFilterType = {
  value: LogOrderFilterValueType;
  displayValue: string;
};

export const logOrderFilter: LogOrderFilterType[] = [
  {
    value: 'new-to-old',
    displayValue: 'New to Old'
  },
  {
    value: 'old-to-new',
    displayValue: 'Old to New'
  }
];

export const filterLogHistory = (
  logHistory: LogMessageWithMeta[],
  logOrder: LogOrderFilterValueType,
  logLevel: LogLevelFilterValueType
): LogMessageWithMeta[] => {
  const orderedLogs = logHistory.sort((a, b) => {
    if (logOrder === 'old-to-new') return a.timestamp > b.timestamp ? 1 : -1;
    if (logOrder === 'new-to-old') return a.timestamp < b.timestamp ? 1 : -1;
    return 0;
  });
  if (logLevel === 'debug') return orderedLogs.filter((log) => log.level === 'debug');
  if (logLevel === 'info') return orderedLogs.filter((log) => log.level === 'info');
  if (logLevel === 'warn') return orderedLogs.filter((log) => log.level === 'warn');
  if (logLevel === 'error') return orderedLogs.filter((log) => log.level === 'error');
  return orderedLogs;
};
